<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M15.8346 9.1665H4.16797V10.8332H15.8346V9.1665Z" fill="white" />
</svg>
